import { render } from "./ConfirmRegistration.vue?vue&type=template&id=2eb423f0&scoped=true"
import script from "./ConfirmRegistration.vue?vue&type=script&lang=js"
export * from "./ConfirmRegistration.vue?vue&type=script&lang=js"

import "./ConfirmRegistration.vue?vue&type=style&index=0&id=2eb423f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb423f0"]])

export default __exports__